export let bootstrapSelect

if (!window.oaFormTemplateHack) {
  bootstrapSelect = require('bootstrap-select')
}